import { render, staticRenderFns } from "./SwatchTraitPreview.vue?vue&type=template&id=c618255e&scoped=true&"
import script from "./SwatchTraitPreview.vue?vue&type=script&lang=ts&"
export * from "./SwatchTraitPreview.vue?vue&type=script&lang=ts&"
import style0 from "./SwatchTraitPreview.vue?vue&type=style&index=0&id=c618255e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c618255e",
  null
  
)

export default component.exports